<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc">
<h2 class="h2" id="toc"><span epub:type="pagebreak" id="page_3"><img alt="Image" class="in100" src="images/line.jpg"/><br/>TABLE OF CONTENTS<br/><img alt="Image" class="in100" src="images/line.jpg"/></span></h2>
<ol>
<li class="toc"><a href="#/xhtml/intro#intro">INTRODUCTION</a></li>
<li class="toc"><a href="#/xhtml/fm1#fmlev1">HOW TO USE THIS BOOK</a></li>
<li class="toc"><a href="#/xhtml/fm2#fmlev2">DRAWING TOOLS &amp; MATERIALS</a></li>
<li class="toc"><span href="#/xhtml/fm3#fmlev3" title="Link target outside of Sample">COLOR TOOLS &amp; MATERIALS</span></li>
<li class="toc"><span href="#/xhtml/fm4#fmlev4" title="Link target outside of Sample">BASIC DRAWING TECHNIQUES</span></li>
<li class="toc"><span href="#/xhtml/fm5#fmlev5" title="Link target outside of Sample">ADDING COLOR</span></li>
<li class="toc"><span href="#/xhtml/fm6#fmlev6" title="Link target outside of Sample">WORKING DIGITALLY</span></li>
<li class="toca"><span href="#/xhtml/ch01#ch01" title="Link target outside of Sample">BORDERS, BANNERS &amp; LETTERS</span>
<ol>
<li class="tocb"><span href="#/xhtml/ch01#ch01lev1" title="Link target outside of Sample">Borders &amp; Banners</span></li>
<li class="tocb"><span href="#/xhtml/ch01#ch01lev2" title="Link target outside of Sample">Lettering</span></li>
<li class="tocb"><span href="#/xhtml/ch01#ch01lev3" title="Link target outside of Sample">Creative Exercise: Lettered Quote &amp; Banner</span></li>
</ol></li>
<li class="toca"><span href="#/xhtml/ch02#ch02" title="Link target outside of Sample">BOTANICALS</span>
<ol>
<li class="tocb"><span href="#/xhtml/ch02#ch02lev04" title="Link target outside of Sample">Leaves &amp; Flowers</span></li>
<li class="tocb"><span href="#/xhtml/ch02#ch02lev05" title="Link target outside of Sample">Tropical Plants</span></li>
<li class="tocb"><span href="#/xhtml/ch02#ch02lev06" title="Link target outside of Sample">Winter Plants</span></li>
<li class="tocb"><span href="#/xhtml/ch02#ch02lev07" title="Link target outside of Sample">Succulents, Cacti &amp; Desert Plants</span></li>
<li class="tocb"><span href="#/xhtml/ch02#ch02lev08" title="Link target outside of Sample">Trees</span></li>
<li class="tocb"><span href="#/xhtml/ch02#ch02lev09" title="Link target outside of Sample">Modern, Stylized Florals</span></li>
<li class="tocb"><span href="#/xhtml/ch02#ch02lev10" title="Link target outside of Sample">Creative Exercise: Terrarium</span></li>
</ol></li>
<li class="toca"><span href="#/xhtml/ch03#ch03" title="Link target outside of Sample">ARCHITECTURE &amp; CITY LIFE</span>
<ol>
<li class="tocb"><span href="#/xhtml/ch03#ch03lev11" title="Link target outside of Sample">City Buildings</span></li>
<li class="tocb"><span href="#/xhtml/ch03#ch03lev12" title="Link target outside of Sample">Distinctive Architecture &amp; Iconic Landmarks</span></li>
<li class="tocb"><span href="#/xhtml/ch03#ch03lev13" title="Link target outside of Sample">Creative Exercise: Storefront</span></li>
</ol></li>
<li class="toca"><span href="#/xhtml/bm01#bmlev1" title="Link target outside of Sample">ANIMALS &amp; INSECTS</span></li>
<li class="toca"><span href="#/xhtml/bm02#bmlev2" title="Link target outside of Sample">EVERYDAY LIFE</span></li>
<li class="toca"><span href="#/xhtml/about#about" title="Link target outside of Sample">ABOUT THE ARTIST</span></li>
</ol>
</nav>
<nav class="hidden" epub:type="landmarks">
<h2>Guide<br/><img alt="Image" class="in100" src="images/line.jpg"/></h2>
<ol>
<li><span epub:type="cover" href="#/xhtml/cover" title="Link target outside of Sample">Cover</span></li>
<li><span epub:type="bodymatter" href="#/xhtml/title" title="Link target outside of Sample">Start Page</span></li>
<li><a epub:type="toc" href="#/xhtml/toc">Contents</a></li>
</ol>
</nav>
<nav class="hidden" epub:type="page-list">
<ol>
<li><a href="#/xhtml/intro#page_4">4</a></li>
<li><a href="#/xhtml/fm1#page_5">5</a></li>
<li><a href="#/xhtml/fm2#page_6">6</a></li>
<li><a href="#/xhtml/fm2#page_7">7</a></li>
<li><span href="#/xhtml/fm3#page_8" title="Link target outside of Sample">8</span></li>
<li><span href="#/xhtml/fm3#page_9" title="Link target outside of Sample">9</span></li>
<li><span href="#/xhtml/fm4#page_10" title="Link target outside of Sample">10</span></li>
<li><span href="#/xhtml/fm4#page_11" title="Link target outside of Sample">11</span></li>
<li><span href="#/xhtml/fm4#page_12" title="Link target outside of Sample">12</span></li>
<li><span href="#/xhtml/fm4#page_13" title="Link target outside of Sample">13</span></li>
<li><span href="#/xhtml/fm5#page_14" title="Link target outside of Sample">14</span></li>
<li><span href="#/xhtml/fm5#page_15" title="Link target outside of Sample">15</span></li>
<li><span href="#/xhtml/fm5#page_16" title="Link target outside of Sample">16</span></li>
<li><span href="#/xhtml/fm5#page_17" title="Link target outside of Sample">17</span></li>
<li><span href="#/xhtml/fm5#page_18" title="Link target outside of Sample">18</span></li>
<li><span href="#/xhtml/fm5#page_19" title="Link target outside of Sample">19</span></li>
<li><span href="#/xhtml/fm6#page_20" title="Link target outside of Sample">20</span></li>
<li><span href="#/xhtml/fm6#page_21" title="Link target outside of Sample">21</span></li>
<li><span href="#/xhtml/fm6#page_22" title="Link target outside of Sample">22</span></li>
<li><span href="#/xhtml/fm6#page_23" title="Link target outside of Sample">23</span></li>
<li><span href="#/xhtml/fm6#page_24" title="Link target outside of Sample">24</span></li>
<li><span href="#/xhtml/fm6#page_25" title="Link target outside of Sample">25</span></li>
<li><span href="#/xhtml/fm6#page_26" title="Link target outside of Sample">26</span></li>
<li><span href="#/xhtml/fm6#page_27" title="Link target outside of Sample">27</span></li>
<li><span href="#/xhtml/ch01#page_28" title="Link target outside of Sample">28</span></li>
<li><span href="#/xhtml/ch01#page_29" title="Link target outside of Sample">29</span></li>
<li><span href="#/xhtml/ch01#page_30" title="Link target outside of Sample">30</span></li>
<li><span href="#/xhtml/ch01#page_31" title="Link target outside of Sample">31</span></li>
<li><span href="#/xhtml/ch01#page_32" title="Link target outside of Sample">32</span></li>
<li><span href="#/xhtml/ch01#page_33" title="Link target outside of Sample">33</span></li>
<li><span href="#/xhtml/ch01#page_34" title="Link target outside of Sample">34</span></li>
<li><span href="#/xhtml/ch01#page_35" title="Link target outside of Sample">35</span></li>
<li><span href="#/xhtml/ch01#page_36" title="Link target outside of Sample">36</span></li>
<li><span href="#/xhtml/ch01#page_37" title="Link target outside of Sample">37</span></li>
<li><span href="#/xhtml/ch01#page_38" title="Link target outside of Sample">38</span></li>
<li><span href="#/xhtml/ch01#page_39" title="Link target outside of Sample">39</span></li>
<li><span href="#/xhtml/ch01#page_40" title="Link target outside of Sample">40</span></li>
<li><span href="#/xhtml/ch01#page_41" title="Link target outside of Sample">41</span></li>
<li><span href="#/xhtml/ch01#page_42" title="Link target outside of Sample">42</span></li>
<li><span href="#/xhtml/ch01#page_43" title="Link target outside of Sample">43</span></li>
<li><span href="#/xhtml/ch01#page_44" title="Link target outside of Sample">44</span></li>
<li><span href="#/xhtml/ch01#page_45" title="Link target outside of Sample">45</span></li>
<li><span href="#/xhtml/ch01#page_46" title="Link target outside of Sample">46</span></li>
<li><span href="#/xhtml/ch01#page_47" title="Link target outside of Sample">47</span></li>
<li><span href="#/xhtml/ch02#page_48" title="Link target outside of Sample">48</span></li>
<li><span href="#/xhtml/ch02#page_49" title="Link target outside of Sample">49</span></li>
<li><span href="#/xhtml/ch02#page_50" title="Link target outside of Sample">50</span></li>
<li><span href="#/xhtml/ch02#page_51" title="Link target outside of Sample">51</span></li>
<li><span href="#/xhtml/ch02#page_52" title="Link target outside of Sample">52</span></li>
<li><span href="#/xhtml/ch02#page_53" title="Link target outside of Sample">53</span></li>
<li><span href="#/xhtml/ch02#page_54" title="Link target outside of Sample">54</span></li>
<li><span href="#/xhtml/ch02#page_55" title="Link target outside of Sample">55</span></li>
<li><span href="#/xhtml/ch02#page_56" title="Link target outside of Sample">56</span></li>
<li><span href="#/xhtml/ch02#page_57" title="Link target outside of Sample">57</span></li>
<li><span href="#/xhtml/ch02#page_58" title="Link target outside of Sample">58</span></li>
<li><span href="#/xhtml/ch02#page_59" title="Link target outside of Sample">59</span></li>
<li><span href="#/xhtml/ch02#page_60" title="Link target outside of Sample">60</span></li>
<li><span href="#/xhtml/ch02#page_61" title="Link target outside of Sample">61</span></li>
<li><span href="#/xhtml/ch02#page_62" title="Link target outside of Sample">62</span></li>
<li><span href="#/xhtml/ch02#page_63" title="Link target outside of Sample">63</span></li>
<li><span href="#/xhtml/ch02#page_64" title="Link target outside of Sample">64</span></li>
<li><span href="#/xhtml/ch02#page_65" title="Link target outside of Sample">65</span></li>
<li><span href="#/xhtml/ch02#page_66" title="Link target outside of Sample">66</span></li>
<li><span href="#/xhtml/ch02#page_67" title="Link target outside of Sample">67</span></li>
<li><span href="#/xhtml/ch02#page_68" title="Link target outside of Sample">68</span></li>
<li><span href="#/xhtml/ch02#page_69" title="Link target outside of Sample">69</span></li>
<li><span href="#/xhtml/ch02#page_70" title="Link target outside of Sample">70</span></li>
<li><span href="#/xhtml/ch02#page_71" title="Link target outside of Sample">71</span></li>
<li><span href="#/xhtml/ch03#page_72" title="Link target outside of Sample">72</span></li>
<li><span href="#/xhtml/ch03#page_73" title="Link target outside of Sample">73</span></li>
<li><span href="#/xhtml/ch03#page_74" title="Link target outside of Sample">74</span></li>
<li><span href="#/xhtml/ch03#page_75" title="Link target outside of Sample">75</span></li>
<li><span href="#/xhtml/ch03#page_76" title="Link target outside of Sample">76</span></li>
<li><span href="#/xhtml/ch03#page_77" title="Link target outside of Sample">77</span></li>
<li><span href="#/xhtml/ch03#page_78" title="Link target outside of Sample">78</span></li>
<li><span href="#/xhtml/ch03#page_79" title="Link target outside of Sample">79</span></li>
<li><span href="#/xhtml/ch03#page_80" title="Link target outside of Sample">80</span></li>
<li><span href="#/xhtml/ch03#page_81" title="Link target outside of Sample">81</span></li>
<li><span href="#/xhtml/ch03#page_82" title="Link target outside of Sample">82</span></li>
<li><span href="#/xhtml/ch03#page_83" title="Link target outside of Sample">83</span></li>
<li><span href="#/xhtml/ch03#page_84" title="Link target outside of Sample">84</span></li>
<li><span href="#/xhtml/ch03#page_85" title="Link target outside of Sample">85</span></li>
<li><span href="#/xhtml/ch03#page_86" title="Link target outside of Sample">86</span></li>
<li><span href="#/xhtml/ch03#page_87" title="Link target outside of Sample">87</span></li>
<li><span href="#/xhtml/ch03#page_88" title="Link target outside of Sample">88</span></li>
<li><span href="#/xhtml/ch03#page_89" title="Link target outside of Sample">89</span></li>
<li><span href="#/xhtml/ch03#page_90" title="Link target outside of Sample">90</span></li>
<li><span href="#/xhtml/ch03#page_91" title="Link target outside of Sample">91</span></li>
<li><span href="#/xhtml/ch03#page_92" title="Link target outside of Sample">92</span></li>
<li><span href="#/xhtml/ch03#page_93" title="Link target outside of Sample">93</span></li>
<li><span href="#/xhtml/ch03#page_94" title="Link target outside of Sample">94</span></li>
<li><span href="#/xhtml/ch03#page_95" title="Link target outside of Sample">95</span></li>
<li><span href="#/xhtml/ch03#page_96" title="Link target outside of Sample">96</span></li>
<li><span href="#/xhtml/ch03#page_97" title="Link target outside of Sample">97</span></li>
<li><span href="#/xhtml/ch03#page_98" title="Link target outside of Sample">98</span></li>
<li><span href="#/xhtml/ch03#page_99" title="Link target outside of Sample">99</span></li>
<li><span href="#/xhtml/ch03#page_100" title="Link target outside of Sample">100</span></li>
<li><span href="#/xhtml/ch03#page_101" title="Link target outside of Sample">101</span></li>
<li><span href="#/xhtml/ch03#page_102" title="Link target outside of Sample">102</span></li>
<li><span href="#/xhtml/ch03#page_103" title="Link target outside of Sample">103</span></li>
<li><span href="#/xhtml/bm01#page_104" title="Link target outside of Sample">104</span></li>
<li><span href="#/xhtml/bm01#page_105" title="Link target outside of Sample">105</span></li>
<li><span href="#/xhtml/bm01#page_106" title="Link target outside of Sample">106</span></li>
<li><span href="#/xhtml/bm01#page_107" title="Link target outside of Sample">107</span></li>
<li><span href="#/xhtml/bm01#page_108" title="Link target outside of Sample">108</span></li>
<li><span href="#/xhtml/bm01#page_109" title="Link target outside of Sample">109</span></li>
<li><span href="#/xhtml/bm01#page_110" title="Link target outside of Sample">110</span></li>
<li><span href="#/xhtml/bm01#page_111" title="Link target outside of Sample">111</span></li>
<li><span href="#/xhtml/bm01#page_112" title="Link target outside of Sample">112</span></li>
<li><span href="#/xhtml/bm01#page_113" title="Link target outside of Sample">113</span></li>
<li><span href="#/xhtml/bm01#page_114" title="Link target outside of Sample">114</span></li>
<li><span href="#/xhtml/bm01#page_115" title="Link target outside of Sample">115</span></li>
<li><span href="#/xhtml/bm02#page_116" title="Link target outside of Sample">116</span></li>
<li><span href="#/xhtml/bm02#page_117" title="Link target outside of Sample">117</span></li>
<li><span href="#/xhtml/bm02#page_118" title="Link target outside of Sample">118</span></li>
<li><span href="#/xhtml/bm02#page_119" title="Link target outside of Sample">119</span></li>
<li><span href="#/xhtml/bm02#page_120" title="Link target outside of Sample">120</span></li>
<li><span href="#/xhtml/bm02#page_121" title="Link target outside of Sample">121</span></li>
<li><span href="#/xhtml/bm02#page_122" title="Link target outside of Sample">122</span></li>
<li><span href="#/xhtml/bm02#page_123" title="Link target outside of Sample">123</span></li>
<li><span href="#/xhtml/bm02#page_124" title="Link target outside of Sample">124</span></li>
<li><span href="#/xhtml/bm02#page_125" title="Link target outside of Sample">125</span></li>
<li><span href="#/xhtml/bm02#page_126" title="Link target outside of Sample">126</span></li>
<li><span href="#/xhtml/about#page_127" title="Link target outside of Sample">127</span></li>
<li><span href="#/xhtml/about#page_128" title="Link target outside of Sample">128</span></li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?311c4f4d